// extracted by mini-css-extract-plugin
export var chart__logoDescr = "ProfessionalServices-module--chart__logoDescr--5pBOV";
export var chart__logoWrapper = "ProfessionalServices-module--chart__logoWrapper--5GyqT";
export var chart__section = "ProfessionalServices-module--chart__section--reHP5";
export var chart__section__item = "ProfessionalServices-module--chart__section__item--HWmjU";
export var chart__wrapper = "ProfessionalServices-module--chart__wrapper--AxzIM";
export var left = "ProfessionalServices-module--left--dV2Ih";
export var right = "ProfessionalServices-module--right--LQtQM";
export var sbShowMain = "ProfessionalServices-module--sb-show-main--Zo7uu";
export var styleRow = "ProfessionalServices-module--styleRow--XbK07";
export var wrapper = "ProfessionalServices-module--wrapper--08Kgs";